// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { Product } from "../../../../common/interfaces/conversionworld/Product";

@Component({
  mixins: [template],
})
export class ProductLink extends Vue {
  @Prop()
  public product!: Product;

  @Prop({ default: "left" })
  public highlightAlign!: "left" | "right";

  @Prop({ default: false })
  public isListView!: boolean;

  @Prop({ default: "" })
  public compareLabel!: string;

  @Prop({ default: "" })
  public maximumCompareLabel!: string;

  @Prop({ default: false })
  public disableCompare!: boolean;

  @Prop({ default: "default" })
  public theme!: "default" | "nba";

  @Prop({ default: "" })
  public vanPartnerText!: string;

  @Prop({ default: "" })
  public vanSolutionText!: string;

  @Prop({ default: "black" })
  backgroundColor!: string;

  get isAlignRight() {
    return this.highlightAlign === "right";
  }

  public finalCompareLabel(id) {
    if (
      this.$store.conversionWorld.isCompareProduct(id) === false &&
      this.$store.conversionWorld.compareProducts.length >= 3
    ) {
      return this.maximumCompareLabel;
    } else {
      return this.compareLabel;
    }
  }
}
